var customer_io_tracking = function(){
  var c = {
    init: function(){
      c.identifyPerson();
      c.trackEvents();
    },
    identifyPerson: function(){
      _cio.identify({
        id: document.getElementById('cio-user-id').value,
        email: document.getElementById('cio-user-id').value,
        created_at: document.getElementById('cio-user-created-at').value,
        unsubscribed: document.getElementById('cio-user-unsubscribed').value,
        direct_client: document.getElementById('cio-user-direct-client').value
      });
    },
    trackEvents: function(){
      // input.cio-event-track type="hidden" data-event-name="Signed In" data-event-data='{"prop": "value"}'
      $.each( $('.cio-event-track'), function(el) {
        var event_name = $(this).data('event-name');
        var event_data = $(this).data('event-data');
        _cio.track(event_name, event_data);
      });

      // a.cio-event-click href="#" data-event-name="Clicked Link" data-event-data='{"prop": "value"}'
      $('.cio-event-click').click( function(el){
        var event_name = $(this).data('event-name');
        var event_data = $(this).data('event-data');
        _cio.track(event_name, event_data);
      })
    }
  };

  return c;
};
if (!!document.getElementById('cio-user-id')) {
  window._cio = window._cio || [];
  (function() {
    var a,b,c;a=function(f){return function(){_cio.push([f].
    concat(Array.prototype.slice.call(arguments, 0)))}};b=["load","identify",
  "sidentify","track","page"];for(c=0;c<b.length;c++){_cio[b[c]] = a(b[c])};
  var t = document.createElement('script'),
  s = document.getElementsByTagName('script')[0];
  t.async = true;
  t.id    = 'cio-tracker';
  t.setAttribute('data-site-id', document.getElementById('cio-site-id').value);
  t.src = 'https://assets.customer.io/assets/track.js';
  t.onload = customer_io_tracking().init();
  s.parentNode.insertBefore(t, s);
  })();
}
